<template>
  <div name="documentation-settings" v-if="files.length">
    <carousel ref="carousel" :perPage="perPage" :navigationEnabled="true" :mouseDrag="false" :centerMode="true">
      <slide v-for="item in files" :key="item.id">
        <div class="ui header">{{ item.name }}</div>
        <div class="actions">
          <button class="ui small green button" :class="{ 'loading' : showLoader && indexClicked === item.id }" @click="downloadDocument(item.id, item.name)">
            <i class="fa fa-download"></i>
          </button>
        </div>
      </slide>
    </carousel>
  </div>
  <div v-else>
    <h3 style="text-align: center;">Ingen dokumenter fundet</h3>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
	name: 'DocumentationSettings',

  components: {
    Carousel,
    Slide
  },

  data () {
    return {
      files: [],
      indexClicked: undefined,
      perPage: 4,
      showLoader: false
    }
  },

  mounted () {
    this.fetchDocumentFiles()
      .then(data => {
        this.files = data
      })
  },

  watch: {
    activeMerchant () {
      this.fetchDocumentFiles()
        .then(data => {
          this.files = data
        })
    }
  },

  methods: {
    fetchDocumentFiles () {
      return new Promise((resolve, reject) => {
        this.axios.get(`merchants/${this.activeMerchant.id}/users/${this.$auth.user().id}/documents`).then(({data}) => {
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    downloadDocument (id, name) {
      this.indexClicked = id
      this.showLoader = true

      this.axios.get(`/users/${this.$auth.user().id}/documents/${id}/download`, {
        responseType: 'blob'
      }).then(response => {
        var headers = response.headers
        const url = window.URL.createObjectURL(new Blob([response.data], {type: headers['content-type']}))
        const link = document.createElement('a')
        link.href = url
        link.download = name
        document.body.appendChild(link)
        link.click()

        this.showLoader = false
      })
    }
  },

  computed: {
    activeMerchant () {
      return this.$store.getters.activeMerchant
    }
  }
}
</script>

<style scoped>
.VueCarousel-slide {
  height: 100px;
  color: #000;
  background: #fff;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  padding: 1%;
  border: 1px solid #ebedec;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/profile/DocumentationSettings.vue